const SubTitleModule = ({ title }: { title: string }) => {
	return <div className="text-lg font-semibold text-[#CECFE6]">{title}</div>
}

export default SubTitleModule
